

















import { computed, defineComponent, nextTick, PropType, ref, toRefs } from '@vue/composition-api';
import { useSmartTextToolsForm, useSmartTextCache } from './hooks';
import { AcoFormData, AdgroupFormData, CampaignFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { StateEnum, useHeaderStyle, useSmartText, useStdCreativeAdgroupIs, useStore } from '@tt4b/ttam-hooks';
import { getCurrentLang, getInstantPageEditorFrameInitData } from '@tt4b/ttam-utils';
import CreativeIframeDrawer from 'src/components/common/creative-iframe-drawer/index.vue';

const name = 'ttam-creative-tool-smart-text-drawer';
export default defineComponent({
  name,
  components: { CreativeIframeDrawer },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const currentLang = getCurrentLang();
    const { adgroupData, campaignData, creativeData } = toRefs(props);
    const { isAco } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { url, isShow, hide, currentSource } = useSmartText();
    const { topHeight } = useHeaderStyle({ headerVisible: ref(true) });
    const { maxNum, existingTexts, setText } = useSmartTextToolsForm({ adgroupData, creativeData, emit });
    const { cache: CreativeToolsCache, setCache } = useSmartTextCache();
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
    const accountInfo = computed(() => state[StateEnum.accountInfo].data.value);

    const initSmartTextData = () => ({
      ad_id: '',
      adv_id: aadvid.value,
      lang: currentLang,
    });

    const onInit = () => {
      const base = getInstantPageEditorFrameInitData({});
      const data = initSmartTextData();
      const multiple = isAco.value;
      const country = accountInfo.value.account?.country || '';
      const result = Object.assign({}, base, data, {
        source: currentSource.value, // 标识入口(title_suggestion/smart_text/translation)
        limit: maxNum.value,
        form_data: CreativeToolsCache.value.formData,
        existing_texts: existingTexts.value,
        adv_region: country,
        multiple,
      });
      return result;
    };

    const onClose = () => {
      hide();
    };

    const onSuccess = message => {
      const {
        form_data,
        request_ids,
        selected_titles: originSelectedTitles = [],
        selected_translations: selectedTranslations = [],
      } = message || {};
      let selectedTitles = originSelectedTitles;
      const isTranslation = Boolean(selectedTranslations?.length);
      if (isTranslation) {
        selectedTitles = selectedTranslations.map(item => ({ ...item, originTitle: item.originTranslation }));
      }
      hide();
      setCache('formData', form_data);
      setCache('requestIds', request_ids);
      setText(selectedTitles, isTranslation);
      nextTick(() => {
        emit('success');
      });
    };

    return {
      name,
      topHeight,
      isShow,
      url,
      currentLang,
      onInit,
      onClose,
      onSuccess,
    };
  },
});
